import { ResponseEnvelop, ServerResponse } from './responses';

/** GiftCard Models */
export interface GiftCard {
  external_order_number: string;
  id: number;
  order_time: string;
  quantity: number;
  state: GiftCardState;
  total: number;
  value: number;
  is_distribute_myself: boolean;
}

export interface GiftCardDiscount {
  discount_amount: number;
  discount_percentage: number;
}

export interface GiftCardProduct {
  sku: string;
  name: string;
  value: GiftCardValueType;
  themes: GiftCardThemeType[];
  created_at: string;
  updated_at: string;
  expiry: string;
}

export interface GiftCardSummary
  extends Omit<GiftCard, 'order_time'>,
    Partial<GiftCardDiscount> {
  created_at: string;
  issued_on: string;
  expires_on: string;
  subtotal: number;
  giftcard_total: number;
  theme_image_url: string;
  message: string;
  num_of_recipients: number;
  is_csv_recipients: boolean;
  recipients?: GiftCardRecipientType[];
  payment_url: string;
  expiry: string;
  number_of_failed_recipients: number;
}

export enum GiftCardState {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  CANCELLED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  PAYMENT_PROCESSING = 'PAYMENT_PROCESSING',
  PAYMENT_REJECTED = 'PAYMENT_REJECTED',
  PARTIALLY_FAILED = 'PARTIALLY_FAILED'
}

export enum DiscountTypes {
  TO_PERCENT = 'TO_PERCENT',
  BY_PERCENT = 'BY_PERCENT',
  BY_FIXED = 'BY_FIXED',
  TO_FIXED = 'TO_FIXED'
}

export enum SkuValueType {
  RANGE = 'RANGE',
  SLAB = 'SLAB'
}

export type GiftCardThemeType = {
  sku: string;
  image: string;
};

export type GiftCardRecipientType = {
  email: string;
  name: string;
};

export type GiftCardValueType = {
  type: SkuValueType;
  min: number;
  max: number;
  denominations: number[];
};

export interface GiftCardCreateSuccess
  extends Pick<
    GiftCardSummary,
    | 'value'
    | 'quantity'
    | 'giftcard_total'
    | 'subtotal'
    | 'total'
    | 'is_distribute_myself'
    | 'num_of_recipients'
    | 'is_csv_recipients'
    | 'external_order_number'
    | 'discount_percentage'
    | 'discount_amount'
  > {
  recipients: string[];
  order_id: number;
}

/** Gift card payloads */

export interface GiftCardUploadCsvPayload {
  id: number;
  formData: FormData;
}

export interface GiftCardDiscountPayload {
  sku: string;
  value: number;
  quantity: number;
}

/** Gift Card Response Types */

export interface GiftCardProductResponse extends ServerResponse {
  data: GiftCardProduct[];
}

export interface GiftCardListResponse extends ServerResponse {
  data: GiftCard[];
  total: number;
}

export interface GiftCardCreateResponse extends ServerResponse {
  data: GiftCardCreateSuccess;
}

export interface GiftCardSummaryResponse extends ServerResponse {
  data: GiftCardSummary;
}

export interface GiftCardRecipientsCsvResponse extends ServerResponse {
  data: Blob;
}

export interface GiftCardDownloadReportResponse extends ServerResponse {
  data: Blob;
}

export type GiftCardDiscountResponse = ResponseEnvelop<GiftCardDiscount>;
